module.exports = __webpack_public_path__ + "img/5.5937c79b.png";